var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_2992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00781 6.66699C5.0377 4.60069 5.19098 3.42921 5.97688 2.6433C6.95319 1.66699 8.52454 1.66699 11.6672 1.66699C14.8099 1.66699 16.3813 1.66699 17.3576 2.6433C18.3339 3.61961 18.3339 5.19096 18.3339 8.33366V11.667C18.3339 14.8097 18.3339 16.381 17.3576 17.3573C16.3813 18.3337 14.8099 18.3337 11.6672 18.3337H10.0005",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 12.0837C1.66602 10.9133 1.66602 10.3281 1.9469 9.90771C2.0685 9.72572 2.22475 9.56947 2.40673 9.44788C2.8271 9.16699 3.4123 9.16699 4.58268 9.16699C5.75307 9.16699 6.33826 9.16699 6.75863 9.44788C6.94062 9.56947 7.09687 9.72572 7.21847 9.90771C7.49935 10.3281 7.49935 10.9133 7.49935 12.0837V15.417C7.49935 16.5874 7.49935 17.1726 7.21847 17.5929C7.09687 17.7749 6.94062 17.9312 6.75863 18.0528C6.33826 18.3337 5.75307 18.3337 4.58268 18.3337C3.4123 18.3337 2.8271 18.3337 2.40673 18.0528C2.22475 17.9312 2.0685 17.7749 1.9469 17.5929C1.66602 17.1726 1.66602 16.5874 1.66602 15.417V12.0837Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 15.833L10 15.833",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_2992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/Devices.09fd2e356953624f560bdbfa50386167.svg";
export { ForwardRef as ReactComponent };